<head>
  <link href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200" rel="stylesheet" />
</head>

<!-- Loader global -->
<div class="loading-overlay" *ngIf="loading">
  <div class="loader-container">
    <div class="loader-spinner"></div>
    <p class="loader-text">Chargement en cours...</p>
  </div>
</div>

<div class="min-h-screen bg-white">
  <div class="max-w-full mx-auto py-6">
        <!-- Crédits disponibles -->
        <div *ngIf="!isAdmin && !isSousAdmin" class="mb-6">
          <app-credit-disponible></app-credit-disponible>
        </div>

        <!-- Conteneur principal -->
        <div class="archive-table-container">
          <!-- Header avec filtre de recherche -->
          <div class="px-6 py-4 border-b border-gray-200 flex items-center gap-4 relative">
            <!-- Filtre de recherche centré avec nombre de résultats à droite -->
            <div class="search-container-fixed flex-1 flex items-center justify-center gap-3">
              <div class="relative w-full max-w-xs">
                <span class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 material-symbols-outlined text-sm pointer-events-none">search</span>
                <input
                  type="text"
                  class="search-input-archive w-full pl-9 pr-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
                  [(ngModel)]="searchTerm"
                  (input)="applyFilter()"
                  placeholder="Rechercher par client ou campagne..."
                />
              </div>
              <span class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-gray-100 text-gray-700 whitespace-nowrap">
                {{ filteredCampagnes.length }} campagne{{ filteredCampagnes.length > 1 ? 's' : '' }}
              </span>
            </div>
          </div>

          <!-- Contenu du tableau -->
          <div class="p-6">
            <!-- Tableau -->
            <div class="overflow-x-auto w-full" style="overflow-x: visible;">
              <table class="w-full border-collapse bg-white" style="table-layout: auto; width: 100%; min-width: 1400px;">
                <thead>
                  <tr class="bg-gradient-to-r from-gray-50 via-gray-100 to-gray-50">
                    <th *ngIf="isAdmin || isSousAdmin" 
                        class="py-3 text-left text-base font-bold text-gray-700 uppercase tracking-wider border-b-2 border-gray-300 cursor-pointer hover:bg-gray-200 transition-colors"
                        style="width: 10%; padding-left: 4px; padding-right: 8px;"
                        (click)="toggleSortClient()">
                      <div class="flex items-center gap-1">
                        <span class="material-symbols-outlined text-lg">people</span>
                        <span>Clients</span>
                        <span *ngIf="sortClientAsc" class="text-blue-600 text-base">▲</span>
                        <span *ngIf="!sortClientAsc" class="text-blue-600 text-base">▼</span>
                      </div>
                    </th>
                    <th class="px-2 py-3 text-center text-sm font-bold text-gray-700 uppercase tracking-wider border-b-2 border-gray-300" style="width: 8%;">
                      Statistiques
                    </th>
                    <th class="px-2 py-4 text-center text-sm font-bold text-gray-700 uppercase tracking-wider border-b-2 border-gray-300" style="width: 5%;">Total</th>
                    <th class="px-2 py-4 text-center text-sm font-bold text-gray-700 uppercase tracking-wider border-b-2 border-gray-300" style="width: 5%;">Doublons</th>
                    <th class="px-2 py-4 text-center text-sm font-bold text-gray-700 uppercase tracking-wider border-b-2 border-gray-300" style="width: 7%; white-space: nowrap;">Too long</th>
                    <th class="px-2 py-4 text-center text-sm font-bold text-gray-700 uppercase tracking-wider border-b-2 border-gray-300" style="width: 6%;">Ancien BL</th>
                    <th class="px-2 py-4 text-center text-sm font-bold text-gray-700 uppercase tracking-wider border-b-2 border-gray-300" style="width: 5%;">Failed</th>
                    <th class="px-2 py-4 text-center text-sm font-bold text-gray-700 uppercase tracking-wider border-b-2 border-gray-300" style="width: 6%;">New BL</th>
                    <th class="px-2 py-4 text-center text-sm font-bold text-gray-700 uppercase tracking-wider border-b-2 border-gray-300" style="width: 5%;">Réponses</th>
                    <th class="px-2 py-4 text-center text-sm font-bold text-gray-700 uppercase tracking-wider border-b-2 border-gray-300" style="width: 12%;">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let c of filteredCampagnes" class="hover:bg-blue-50 transition-all duration-150 border-b border-gray-100 group">
                    <td *ngIf="isAdmin || isSousAdmin" 
                        class="py-3 text-left font-medium text-base"
                        style="padding-left: 4px; padding-right: 8px;">
                      <div class="flex flex-col gap-1">
                        <div class="client-name-clickable truncate text-base font-medium cursor-pointer inline-block" 
                             [title]="'ID: ' + c._id + ' (cliquez pour copier)'"
                             (click)="copyRefCampagne(c._id, $event)">
                          {{ getClientIdentifiant(c.idClient) }} - {{ c.nomCampagne }}
                        </div>
                        <div class="text-sm text-gray-400 flex items-center gap-1">
                          <span class="material-symbols-outlined text-sm">schedule</span>
                          <span class="truncate max-w-[200px]">{{ formatDateCampagne(c) }}</span>
                        </div>
                      </div>
                    </td>
                    <td class="px-2 py-3 text-center">
                      <div class="suivi-stats-row-modern">
                        <div class="suivi-stat-badge-modern suivi-stat-badge-green" title="Pourcentage de progression">
                          <span class="stat-number">{{ getPercentage(c) }}%</span>
                        </div>
                        <div class="suivi-stat-badge-modern suivi-stat-badge-red" title="Pourcentage Failed">
                          <span class="stat-number">{{ getFailedPercentage(c) }}%</span>
                        </div>
                      </div>
                    </td>
                    <td class="px-2 py-4 text-center">
                      <div class="flex items-center justify-center gap-1.5">
                        <button 
                          class="download-btn-icon p-1.5 rounded-md text-gray-400 hover:text-blue-600 hover:bg-blue-50 transition-all duration-200"
                          (click)="exporter('total', c._id)" 
                          title="Télécharger">
                          <span class="material-symbols-outlined text-base">download</span>
                        </button>
                        <span class="font-semibold text-gray-900 text-base">{{ c.total + c.nbAncienBlacklist }}</span>
                      </div>
                    </td>
                    <td class="px-2 py-4 text-center">
                      <div class="flex items-center justify-center gap-1.5">
                        <button 
                          class="download-btn-icon p-1.5 rounded-md text-gray-400 hover:text-blue-600 hover:bg-blue-50 transition-all duration-200"
                          (click)="exporter('duplicate', c._id)" 
                          title="Télécharger">
                          <span class="material-symbols-outlined text-base">download</span>
                        </button>
                        <span class="font-semibold text-gray-900 text-base">{{ c.nombreDuplicate }}</span>
                      </div>
                    </td>
                    <td class="px-2 py-4 text-center">
                      <div class="flex items-center justify-center gap-1.5">
                        <button 
                          class="download-btn-icon p-1.5 rounded-md text-gray-400 hover:text-blue-600 hover:bg-blue-50 transition-all duration-200"
                          (click)="exporter('tooLong', c._id)" 
                          title="Télécharger">
                          <span class="material-symbols-outlined text-base">download</span>
                        </button>
                        <span class="font-semibold text-gray-900 text-base">{{ c.nombreTooLong }}</span>
                      </div>
                    </td>
                    <td class="px-2 py-4 text-center">
                      <span class="font-semibold text-gray-900 text-base">{{ c.nbAncienBlacklist }}</span>
                    </td>
                    <td class="px-2 py-4 text-center">
                      <div class="flex items-center justify-center gap-1.5">
                        <button 
                          class="download-btn-icon p-1.5 rounded-md text-gray-400 hover:text-blue-600 hover:bg-blue-50 transition-all duration-200"
                          (click)="exporter('failed', c._id)" 
                          title="Télécharger">
                          <span class="material-symbols-outlined text-base">download</span>
                        </button>
                        <span class="inline-flex items-center justify-center px-2.5 py-1 rounded-md text-sm font-semibold" style="background-color: #fee2e2; color: #dc2626;">{{ c.failed }}</span>
                      </div>
                    </td>
                    <td class="px-2 py-4 text-center">
                      <div class="flex items-center justify-center gap-1.5">
                        <button 
                          class="download-btn-icon p-1.5 rounded-md text-gray-400 hover:text-blue-600 hover:bg-blue-50 transition-all duration-200"
                          (click)="exporter('stops', c._id)" 
                          title="Télécharger">
                          <span class="material-symbols-outlined text-base">download</span>
                        </button>
                        <span class="font-semibold text-gray-900 text-base">{{ c.nombreStop }}</span>
                      </div>
                    </td>
                    <td class="px-2 py-4 text-center">
                      <div class="flex items-center justify-center gap-1.5">
                        <button 
                          class="download-btn-icon p-1.5 rounded-md text-gray-400 hover:text-blue-600 hover:bg-blue-50 transition-all duration-200"
                          (click)="exporter('reception', c._id)" 
                          title="Télécharger">
                          <span class="material-symbols-outlined text-base">download</span>
                        </button>
                        <span class="font-semibold text-gray-900 text-base">{{ c.nombreReception }}</span>
                      </div>
                    </td>
                    <td class="px-2 py-3 text-center">
                      <div class="actions-row-modern">
                        <button 
                          type="button"
                          class="btn-action-modern btn-reload-failed"
                          (click)="relancerFailed(c._id)"
                          title="Relancer failed">
                          <span class="material-symbols-outlined">refresh</span>
                        </button>
                        <button 
                          type="button"
                          class="btn-action-modern"
                          [ngClass]="c.considererArchive ? 'btn-archive-active' : 'btn-archive-inactive'"
                          (click)="updateConsiderArchive(c._id)"
                          [title]="c.considererArchive ? 'Ne plus prendre en compte pour le dédoublonnage' : 'Prendre en compte pour le dédoublonnage'">
                          <span class="material-symbols-outlined">{{ c.considererArchive ? 'check_circle' : 'radio_button_unchecked' }}</span>
                        </button>
                        <button 
                          type="button"
                          class="btn-action-modern btn-delete"
                          (click)="supprimer(c._id)"
                          title="Supprimer">
                          <span class="material-symbols-outlined">delete</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="filteredCampagnes.length === 0" class="hover:bg-blue-50 transition-all duration-150">
                    <td [attr.colspan]="(isAdmin || isSousAdmin ? 10 : 9)" class="px-6 py-12 text-center">
                      <div class="flex flex-col items-center gap-3">
                        <span class="material-symbols-outlined text-5xl text-gray-300">archive</span>
                        <p class="text-gray-500 text-lg font-medium" *ngIf="searchTerm">Aucun résultat trouvé pour "{{ searchTerm }}"</p>
                        <p class="text-gray-500 text-lg font-medium" *ngIf="!searchTerm">Aucune campagne archivée</p>
                        <p class="text-gray-400 text-sm" *ngIf="!searchTerm">Les campagnes archivées apparaîtront ici</p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
</div>
